import request from '../request';
import { url } from './config';
import type { Reminder, ReminderInput } from './types';

/** Personal reminders — every call is scoped to the signed-in user on the server. */
const remindersApi = {
    async list(): Promise<Reminder[]> {
        return (await request.get(url)).data;
    },
    async due(): Promise<Reminder[]> {
        return (await request.get(`${url}/due`)).data;
    },
    async create(input: ReminderInput): Promise<Reminder> {
        return (await request.post(url, input)).data;
    },
    async update(id: number, input: ReminderInput): Promise<Reminder> {
        return (await request.put(`${url}/${id}`, input)).data;
    },
    async setCompleted(id: number, completed: boolean): Promise<Reminder> {
        return (await request.post(`${url}/${id}/complete`, { completed })).data;
    },
    async snooze(id: number, minutes: number): Promise<Reminder> {
        return (await request.post(`${url}/${id}/snooze`, { minutes })).data;
    },
    async remove(id: number): Promise<void> {
        await request.delete(`${url}/${id}`);
    }
};

export default remindersApi;
